import { render, staticRenderFns } from "./backPassword.vue?vue&type=template&id=6c6610f0&scoped=true"
import script from "./backPassword.vue?vue&type=script&lang=js"
export * from "./backPassword.vue?vue&type=script&lang=js"
import style0 from "./backPassword.vue?vue&type=style&index=0&id=6c6610f0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c6610f0",
  null
  
)

export default component.exports